import { render, staticRenderFns } from "./PurchaseType.vue?vue&type=template&id=3c575b03&"
import script from "./PurchaseType.vue?vue&type=script&lang=js&"
export * from "./PurchaseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports